
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin } from '../../mixins';

@Component
export default class TrophySvg extends Mixins(VuetifyMixin){
	@Prop({ default: 'white' }) private color: string;
	@Prop({ default: 17 }) private size: number;
	get Color(): string{
		return this.getColor(this.color);
	}
}
